module.exports = __webpack_public_path__ + "assets/normal/images/progress-none.7d38396c.png";